/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconMuted from '@telus-uds/palette-public-mobile/build/rn/icons/Muted'
import PaletteIconUnmuted from '@telus-uds/palette-public-mobile/build/rn/icons/Unmuted'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    marginLeft: 16,
    marginRight: 16,
    mutedIcon: PaletteIconMuted,
    rangeBackground: 'rgba(0, 0, 0, 0)',
    thumbBackground: '#ffffff',
    thumbHeight: 8,
    thumbWidth: 8,
    trackGradientEnd: '#ffffff',
    trackGradientStart: '#ffffff',
    unmutedIcon: PaletteIconUnmuted
  }
}
export default theme
